import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-background-100 mt-16">
      <div className="w-full px-4 md:px-8 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex items-center justify-center w-9 h-9 rounded-md bg-primary-500 text-background-50">
                <i className="ri-movie-2-fill text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">芭乐视频</span>
            </div>
            <p className="mt-4 text-sm text-background-200/80 leading-relaxed max-w-md">
              芭乐视频是一个多元化高清视频内容聚合平台，涵盖电影、电视剧、动漫等热门类别，
              致力于帮助用户高效发现并获取优质视听资源。当前版本以内容展示为主，播放功能敬请期待。
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-3">
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-50/10 text-xs text-background-100">
                <i className="ri-mail-line" /> service@balevideo.com
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-50/10 text-xs text-background-100">
                <i className="ri-phone-line" /> 400-880-1200
              </span>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">
              <Link to="/" className="hover:text-primary-300 transition-colors">内容导航</Link>
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm text-background-200/80">
              <li><Link to="/category/电影" className="hover:text-primary-300 transition-colors">电影频道</Link></li>
              <li><Link to="/category/电视剧" className="hover:text-primary-300 transition-colors">电视剧频道</Link></li>
              <li><Link to="/category/动漫" className="hover:text-primary-300 transition-colors">动漫频道</Link></li>
              <li><Link to="/search" className="hover:text-primary-300 transition-colors">全站搜索</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">
              <Link to="/about" className="hover:text-primary-300 transition-colors">关于与帮助</Link>
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm text-background-200/80">
              <li><Link to="/about" className="hover:text-primary-300 transition-colors">关于我们</Link></li>
              <li><Link to="/about" className="hover:text-primary-300 transition-colors">联系方式</Link></li>
              <li><Link to="/about" className="hover:text-primary-300 transition-colors">版权声明</Link></li>
              <li><span className="text-background-200/60">友情链接：影视观察 / 光影日报</span></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-200/60">
          <p>© 2026 芭乐视频 Bale Video. 保留所有权利。</p>
          <p>本站内容均为演示数据，不提供实际播放与下载功能。</p>
        </div>
      </div>
    </footer>
  );
}